/* Esquenta Black — comportamentos da coleção (contagem, cupom, filtros, Lista VIP).
   Seguro para rodar várias vezes: cada bloco é marcado com data-kce-ready. */
(function () {
  function pad(n) { return String(n).padStart(2, '0'); }

  function initCountdown(root) {
    root.querySelectorAll('[data-kce-end]:not([data-kce-ready])').forEach(function (el) {
      el.setAttribute('data-kce-ready', '1');
      var end = new Date(el.getAttribute('data-kce-end')).getTime();
      if (isNaN(end)) return;
      var d = el.querySelector('[data-u="d"]'), h = el.querySelector('[data-u="h"]'),
          m = el.querySelector('[data-u="m"]'), s = el.querySelector('[data-u="s"]'),
          label = el.querySelector('.kce-count__label');
      function tick() {
        var diff = end - Date.now();
        if (diff <= 0) {
          el.setAttribute('data-ended', '');
          if (label) label.textContent = el.getAttribute('data-kce-ended-text') || '';
          clearInterval(timer);
          return;
        }
        var t = Math.floor(diff / 1000);
        d.textContent = pad(Math.floor(t / 86400));
        h.textContent = pad(Math.floor(t % 86400 / 3600));
        m.textContent = pad(Math.floor(t % 3600 / 60));
        s.textContent = pad(t % 60);
      }
      var timer = setInterval(tick, 1000);
      tick();
    });
  }

  function initCopy(root) {
    root.querySelectorAll('[data-kce-copy]:not([data-kce-ready])').forEach(function (btn) {
      btn.setAttribute('data-kce-ready', '1');
      var status = document.getElementById(btn.getAttribute('aria-describedby'));
      btn.addEventListener('click', function () {
        var code = btn.getAttribute('data-kce-copy');
        function done(ok) {
          if (!status) return;
          status.innerHTML = ok ? 'Cupom <b>' + code + '</b> copiado. Cole no checkout.' : 'Use o cupom <b>' + code + '</b> no checkout.';
        }
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(function () { done(true); }, function () { done(false); });
        } else {
          var ta = document.createElement('textarea');
          ta.value = code; ta.setAttribute('readonly', ''); ta.style.position = 'absolute'; ta.style.left = '-9999px';
          document.body.appendChild(ta); ta.select();
          var ok = false; try { ok = document.execCommand('copy'); } catch (e) {}
          document.body.removeChild(ta); done(ok);
        }
      });
    });
  }

  function initFilters(root) {
    root.querySelectorAll('[data-kce-filters]:not([data-kce-ready])').forEach(function (bar) {
      bar.setAttribute('data-kce-ready', '1');
      var grid = document.getElementById(bar.getAttribute('data-kce-filters'));
      if (!grid) return;
      bar.addEventListener('click', function (e) {
        var b = e.target.closest('[data-cat]');
        if (!b) return;
        var cat = b.getAttribute('data-cat');
        bar.querySelectorAll('[data-cat]').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        grid.querySelectorAll('.kce-card').forEach(function (c) {
          c.hidden = !(cat === 'all' || c.getAttribute('data-cat') === cat);
        });
      });
    });
  }

  function initVip(root) {
    root.querySelectorAll('[data-kce-vip]:not([data-kce-ready])').forEach(function (box) {
      box.setAttribute('data-kce-ready', '1');
      var f = box.querySelector('form'), inp = box.querySelector('input[type=email]'),
          btn = box.querySelector('button'), msg = box.querySelector('.kce-vip__msg');
      function say(t, ok) { msg.textContent = t; msg.className = 'kce-vip__msg ' + (ok ? 'is-ok' : 'is-err'); }
      f.addEventListener('submit', function (e) {
        e.preventDefault();
        var email = (inp.value || '').trim();
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { say('Digite um e-mail válido.', false); return; }
        if (!box.dataset.list) { say('Lista VIP ainda não configurada no editor do tema.', false); return; }
        btn.disabled = true;
        fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + box.dataset.company, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', revision: '2025-04-15' },
          body: JSON.stringify({ data: { type: 'subscription', attributes: { custom_source: box.dataset.source,
            profile: { data: { type: 'profile', attributes: { email: email } } } },
            relationships: { list: { data: { type: 'list', id: box.dataset.list } } } } })
        }).then(function (r) {
          if (!r.ok) throw 0;
          say(box.dataset.success, true); inp.value = '';
        }).catch(function () {
          say('Não foi possível cadastrar agora. Tente de novo em instantes.', false);
        }).then(function () { btn.disabled = false; });
      });
    });
  }

  function init(root) {
    root = root || document;
    initCountdown(root); initCopy(root); initFilters(root); initVip(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
